/* SeattleWallWraps.com — Before / after compare slider (Builder B, "Spatial Scan").
   sections/cwv-before-after.liquid
   - Each viewport has a real <input type="range"> (0-100 = how much of the "before" shows, from the left)
     laid over it: keyboard (arrows, PageUp/PageDown, Home/End) and screen readers drive it natively.
   - Mouse: press anywhere and drag. Touch: a horizontal drag moves the divider, a tap jumps it, and a
     vertical swipe still scrolls the page (the viewport has touch-action: pan-y).
   - Several pairs = ARIA tabs (arrow keys / Home / End) plus prev / next buttons under the viewport.
   Vanilla JS, one namespace: window.CWV.beforeAfter. Works with several instances per page. */
(function () {
  'use strict';

  var CWV = (window.CWV = window.CWV || {});
  if (CWV.beforeAfter) return;

  var doc = document;
  var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------- One compare viewport ---------- */
  function Compare(stage) {
    var self = this;
    this.stage = stage;
    this.range = $('[data-cwv-ba-range]', stage);
    this.ptr = null;
    this.pending = null;
    this.set(this.range ? parseFloat(this.range.value) : 50);

    this.onInput = function () { self.touched(); self.set(parseFloat(self.range.value), true); };
    if (this.range) {
      this.range.addEventListener('input', this.onInput);
      this.range.addEventListener('change', this.onInput);
    }

    this.onDown = function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      self.rect = stage.getBoundingClientRect();
      self.ptr = { id: e.pointerId, type: e.pointerType, x: e.clientX, y: e.clientY, drag: false };
      if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
        e.preventDefault();
        self.startDrag(e);
        self.moveTo(e.clientX);
      }
    };
    this.onMove = function (e) {
      var p = self.ptr;
      if (!p || e.pointerId !== p.id) return;
      if (!p.drag) {
        var dx = Math.abs(e.clientX - p.x), dy = Math.abs(e.clientY - p.y);
        if (dx > 6 && dx > dy) self.startDrag(e);
        else if (dy > 10) { self.ptr = null; return; }
        else return;
      }
      if (e.cancelable) e.preventDefault();
      self.moveTo(e.clientX);
    };
    this.onUp = function (e) {
      var p = self.ptr;
      if (!p || e.pointerId !== p.id) return;
      if (!p.drag) { self.touched(); self.rect = stage.getBoundingClientRect(); self.moveTo(e.clientX); }
      self.endDrag(e);
    };
    this.onCancel = function (e) {
      var p = self.ptr;
      if (!p || e.pointerId !== p.id) return;
      self.endDrag(e);
    };
    /* touch pointers start implicitly captured by the touched child; moving capture to the stage fires
       lostpointercapture on that child, which bubbles here, so only the stage's own loss ends a drag */
    this.onLost = function (e) { if (e.target === stage) self.onCancel(e); };
    this.onDragStart = function (e) { e.preventDefault(); };

    stage.addEventListener('pointerdown', this.onDown);
    stage.addEventListener('pointermove', this.onMove);
    stage.addEventListener('pointerup', this.onUp);
    stage.addEventListener('pointercancel', this.onCancel);
    stage.addEventListener('lostpointercapture', this.onLost);
    stage.addEventListener('dragstart', this.onDragStart);
  }

  Compare.prototype.startDrag = function (e) {
    this.ptr.drag = true;
    this.touched();
    this.stage.classList.add('is-dragging');
    try { this.stage.setPointerCapture(e.pointerId); } catch (err) {}
    if (this.ptr.type !== 'touch') focusEl(this.range);
  };

  Compare.prototype.endDrag = function (e) {
    this.ptr = null;
    this.stage.classList.remove('is-dragging');
    try { if (this.stage.hasPointerCapture && this.stage.hasPointerCapture(e.pointerId)) this.stage.releasePointerCapture(e.pointerId); } catch (err) {}
  };

  Compare.prototype.moveTo = function (clientX) {
    var self = this, r = this.rect;
    if (!r || !r.width) return;
    this.pending = (clientX - r.left) / r.width * 100;
    if (this.frame) return;
    this.frame = raf(function () {
      self.frame = null;
      if (self.pending !== null) { self.set(self.pending); self.pending = null; }
    });
  };

  Compare.prototype.touched = function () {
    if (!this.isTouched) { this.isTouched = true; this.stage.classList.add('is-touched'); }
  };

  Compare.prototype.set = function (p, fromInput) {
    if (isNaN(p)) p = 50;
    p = Math.max(0, Math.min(100, p));
    this.pos = p;
    this.stage.style.setProperty('--pos', p.toFixed(2) + '%');
    var r = Math.round(p);
    if (this.range) {
      if (!fromInput) this.range.value = String(r);
      this.range.setAttribute('aria-valuetext', 'Before ' + r + '%, after ' + (100 - r) + '%');
    }
    this.stage.classList.toggle('is-before-low', p < 16);
    this.stage.classList.toggle('is-after-low', p > 84);
  };

  Compare.prototype.destroy = function () {
    var s = this.stage;
    if (this.range) {
      this.range.removeEventListener('input', this.onInput);
      this.range.removeEventListener('change', this.onInput);
    }
    s.removeEventListener('pointerdown', this.onDown);
    s.removeEventListener('pointermove', this.onMove);
    s.removeEventListener('pointerup', this.onUp);
    s.removeEventListener('pointercancel', this.onCancel);
    s.removeEventListener('lostpointercapture', this.onLost);
    s.removeEventListener('dragstart', this.onDragStart);
  };

  /* ---------- Section: tabs + viewports ---------- */
  function BeforeAfter(root) {
    var self = this;
    this.root = root;
    this.panels = $$('[data-cwv-ba-panel]', root);
    this.tabs = $$('[data-cwv-ba-tab]', root);
    this.tablist = $('[data-cwv-ba-tablist]', root);
    this.live = $('[data-cwv-ba-live]', root);
    this.compares = $$('[data-cwv-ba-stage]', root).map(function (s) { return new Compare(s); });
    this.idx = 0;
    this.panels.forEach(function (p, i) { if (p.classList.contains('is-active')) self.idx = i; });

    this.onClick = function (e) {
      var t = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!t || !root.contains(t)) return;
      if (t.hasAttribute('data-cwv-ba-tab')) { self.activate(self.tabs.indexOf(t)); return; }
      if (t.hasAttribute('data-cwv-ba-prev')) { self.activate(self.idx - 1, { keep: 'data-cwv-ba-prev', announce: true }); return; }
      if (t.hasAttribute('data-cwv-ba-next')) { self.activate(self.idx + 1, { keep: 'data-cwv-ba-next', announce: true }); }
    };
    root.addEventListener('click', this.onClick);

    this.onKey = function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      var t = e.target;
      if (!t || !t.hasAttribute || !t.hasAttribute('data-cwv-ba-tab')) return;
      var i = self.tabs.indexOf(t), j = -1, n = self.tabs.length;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault();
      self.activate(j, { focusTab: true });
    };
    if (this.tablist) this.tablist.addEventListener('keydown', this.onKey);
  }

  BeforeAfter.prototype.activate = function (i, opts) {
    opts = opts || {};
    var n = this.panels.length;
    if (!n) return;
    i = ((i % n) + n) % n;
    var prev = this.idx;
    this.idx = i;
    this.panels.forEach(function (p, k) {
      var on = k === i;
      p.hidden = !on;
      p.classList.toggle('is-active', on);
    });
    this.tabs.forEach(function (t, k) {
      var on = k === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    var tab = this.tabs[i];
    if (tab && this.tablist && this.tablist.scrollWidth > this.tablist.clientWidth + 2) {
      var left = tab.offsetLeft - parseFloat(window.getComputedStyle(this.tablist).paddingLeft || 0);
      try { this.tablist.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { this.tablist.scrollLeft = left; }
    }
    if (opts.focusTab && tab) focusEl(tab);
    if (opts.keep) focusEl($('[' + opts.keep + ']', this.panels[i]));
    if (opts.announce && this.live && prev !== i) {
      var cap = $('.cwv-ba__caption', this.panels[i]);
      this.live.textContent = 'Before and after ' + pad(i + 1) + ' of ' + pad(n) + (cap ? ': ' + cap.textContent.trim() : '');
    }
  };

  BeforeAfter.prototype.selectBlock = function (el) {
    var p = el.closest ? el.closest('[data-cwv-ba-panel]') : null;
    var i = this.panels.indexOf(p);
    if (i >= 0) this.activate(i);
  };

  BeforeAfter.prototype.destroy = function () {
    this.root.removeEventListener('click', this.onClick);
    if (this.tablist) this.tablist.removeEventListener('keydown', this.onKey);
    this.compares.forEach(function (c) { c.destroy(); });
  };

  function init(scope) {
    $$('[data-cwv-before-after]', scope).forEach(function (el) { if (!el.cwvBA) el.cwvBA = new BeforeAfter(el); });
  }
  function destroy(scope) {
    $$('[data-cwv-before-after]', scope).forEach(function (el) {
      if (el.cwvBA) el.cwvBA.destroy();
      el.cwvBA = null;
    });
  }

  CWV.beforeAfter = { init: init, destroy: destroy };

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);

  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  doc.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
  doc.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    var root = t && t.closest ? t.closest('[data-cwv-before-after]') : null;
    if (root && root.cwvBA) root.cwvBA.selectBlock(t);
  });
})();
